import { useState } from 'react'

import ContentWithSubTabs from 'Components/UI/Molecules/ContentWithSubTabs'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'

import { Gral } from './Gral'
import { Settings } from './Settings'

const Home = (props) => {
  const { concept, tipoOblea, setSelectedConcept, edit, constants } = props

  const [tab, setTab] = useState(0)

  function renderTabs(index) {
    switch (index) {
      case 0:
        return (
          <InputsWithoutValidate
            fields={Gral(concept, tipoOblea, edit, setSelectedConcept)}
            spacing={2}
          />
        )
      case 1:
        return (
          <InputsWithoutValidate
            fields={Settings(concept, edit, setSelectedConcept, constants)}
            spacing={2}
          />
        )
      default:
        break
    }
  }

  const verticalTabs = [
    {
      id: 0,
      title: 'General',
    },
    {
      id: 1,
      title: 'Configuración',
    },
  ]

  return (
    <div>
      <ContentWithSubTabs
        listVerticalTabs={verticalTabs}
        value={tab}
        setValue={setTab}
        children={<div style={{ margin: '20px' }}>{renderTabs(tab)}</div>}
      />
    </div>
  )
}

export default Home
